import { render, staticRenderFns } from "./ad-management.vue?vue&type=template&id=ba4a00e8&scoped=true"
import script from "./ad-management.vue?vue&type=script&lang=js"
export * from "./ad-management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4a00e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba4a00e8')) {
      api.createRecord('ba4a00e8', component.options)
    } else {
      api.reload('ba4a00e8', component.options)
    }
    module.hot.accept("./ad-management.vue?vue&type=template&id=ba4a00e8&scoped=true", function () {
      api.rerender('ba4a00e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/system-management/ad-management/ad-management.vue"
export default component.exports